/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListExtensionsRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tool_endpoint_messages.pb'
import {ListExtensionsResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tool_endpoint_messages.pb'


export const listExtensions = (request: ListExtensionsRequest, options?: CashRequestOptions) => post<ListExtensionsRequest, ListExtensionsResponse>("/2.0/cash/list-extensions", request, {...options, rejectOnError: true })